export enum CardStates {
    ReadOnly = 'Read only',
    CanEdit = 'Can edit',
    IsEditingCannotSubmit = 'Is editing, Cannot submit',
    IsEditingCanSubmit = 'Is editing, Can submit',
    WasEditedIsUnsaved = 'Was edited, Is unsaved',
    IsSaved = 'Is saved',
}
